module.exports = __webpack_public_path__ + "static/media/forward-10.b43a7473.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/forward-10.svg
// module id = 976
// module chunks = 0